import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, action, image }) {
  return (
    <div className="relative overflow-hidden border-b border-border/60 brand-gradient">
      {image && (
        <img src={image} alt="" className="absolute right-0 top-0 h-full w-1/3 object-cover opacity-20 mix-blend-luminosity" />
      )}
      <div className="relative px-4 sm:px-8 py-6 flex items-end justify-between flex-wrap gap-4">
        <div>
          {eyebrow && <p className="eyebrow text-gold mb-1.5">{eyebrow}</p>}
          <h1 className="text-2xl sm:text-3xl font-serif font-semibold text-white">{title}</h1>
          {subtitle && <p className="text-emerald-100/60 text-sm mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
    </div>
  );
}
